import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-credit-card-bill-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './credit-card-bill-form.html',
  styleUrl: './credit-card-bill-form.scss',
})
export class CreditCardBillForm implements OnInit {
  @Input() category: any;
  @Input() minDue: number = 1200;
  @Input() totalDue: number = 12450;

  // Dynamic card inputs from parent
  @Input() cards: any[] = [];
  @Input() selectedCard: any = null;

  // Navigation events
  @Output() close = new EventEmitter<void>();
  @Output() back = new EventEmitter<any>();
  @Output() next = new EventEmitter<{ amount: number, type: 'min' | 'full' | 'custom' }>();

  // State
  selectedOption: 'min' | 'full' | 'custom' = 'full';
  customAmount: number | null = null;
  step: 'select-amount' | 'review' | 'credit-cards' | 'credit-categories' = 'select-amount';

  // Dropdown State
  isDropdownOpen: boolean = false;
  selectedPayCard = { bank: 'HDFC Bank', number: '1234', id: '1' };

  availableCards: any[] = [];

  constructor() { }

  ngOnInit(): void {
    // Initialize available cards from parent input
    if (this.cards && this.cards.length > 0) {
      this.availableCards = this.cards.map(c => ({
        id: c.id,
        bank: c.bank,
        number: c.lastFour
      }));
    }
    // Set the initially selected card from parent
    if (this.selectedCard) {
      this.selectedPayCard = {
        id: this.selectedCard.id,
        bank: this.selectedCard.bank,
        number: this.selectedCard.lastFour
      };
    } else if (this.availableCards.length > 0) {
      this.selectedPayCard = this.availableCards[0];
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectPayCard(card: any): void {
    this.selectedPayCard = card;
    this.isDropdownOpen = false;
  }

  addNewCard(): void {
    this.isDropdownOpen = false;
  }

  get payAmount(): number {
    if (this.selectedOption === 'min') return this.minDue;
    if (this.selectedOption === 'full') return this.totalDue;
    return this.customAmount || 0;
  }

  selectOption(option: 'min' | 'full' | 'custom'): void {
    this.selectedOption = option;
    if (option !== 'custom') {
      this.customAmount = null;
    }
  }

  onCustomAmountFocus(): void {
    this.selectOption('custom');
  }

  get isValid(): boolean {
    if (this.selectedOption === 'min' || this.selectedOption === 'full') return true;
    // Custom amount validation
    return !!this.customAmount && this.customAmount >= this.minDue && this.customAmount <= this.totalDue;
  }

  goBack(): void {
    if (this.step === 'review') {
      this.step = 'select-amount';
    } else {
      // Prioritize emitting close if needed for parent compatibility, or use back
      this.close.emit();
      this.back.emit('credit-form');
    }
  }

  proceed(): void {
    if (this.isValid) {
      this.step = 'review';
    }
  }

  confirm(): void {
    this.next.emit({
      amount: this.payAmount,
      type: this.selectedOption
    });
    this.back.emit('credit-form');
  }
}
